import axios from "../axios-defaults";

class Comment {
  createComment(data) {
    return axios.post("/api/v1/comments", data);
  }

  getComments(q = "", page) {
    return axios.get(`/api/v1/comments?page=${page}&q=${q}&is_visible=1`);
  }

  getAllComments(q = "", page) {
    return axios.get(`/api/v1/comments?page=${page}&q=${q}`);
  }

  updateComment(id, data) {
    Object.assign(data, { _method: "patch" });
    return axios.post(`/api/v1/comments/${id}`, data);
  }

  DeleteComment(id) {
    return axios.delete(`/api/v1/comments/${id}`);
  }

  updateCommentVisibility(id, isVisible) {
    return axios.patch(`/api/v1/comments/${id}/visible`, {
      is_visible: isVisible,
    });
  }
}

const obj = new Comment();

export default obj;
